import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { RouterLink } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { BreadcrumbService } from "../breadcrumb.service";
import { CommandPaletteComponent } from "../command-palette/command-palette.component";
import { ShellNavService } from "../shell-nav.service";

@Component({
	selector: "mch-shell-topbar",
	standalone: true,
	imports: [
		AsyncPipe,
		MatButtonModule,
		MatDividerModule,
		MatIconModule,
		MatMenuModule,
		RouterLink,
		CommandPaletteComponent,
	],
	templateUrl: "./shell-topbar.component.html",
	styleUrl: "./shell-topbar.component.scss",
})
export class ShellTopbarComponent {
	private readonly authService = inject(AuthService);
	protected readonly nav = inject(ShellNavService);
	protected readonly breadcrumbs = inject(BreadcrumbService);

	protected readonly user$ = this.authService.userDoc$;

	protected toggleRail(): void {
		this.nav.toggleRail();
	}

	protected async logout(): Promise<void> {
		try {
			await this.authService.logout();
		} catch (error) {
			console.error("Logout failed:", error);
		}
	}

	protected onImageError(event: Event): void {
		(event.target as HTMLImageElement).src = "/default-avatar.webp";
	}
}
